import * as classicApi from "@/api/episode.api"
import * as botApi from "@/api/podcastBotEpisodes.api"

export const getEpisodes = (podcastKey, params, isAiPodcast) =>
  isAiPodcast ? botApi.getBotPodcastEpisodes(podcastKey, params) : classicApi.getEpisodes(podcastKey, params)

export const getEpisode = (podcastKey, episodeKey, isAiPodcast) =>
  isAiPodcast ? botApi.getBotPodcastEpisode(podcastKey, episodeKey) : classicApi.getEpisode(podcastKey, episodeKey)

export const createEpisode = (podcastKey, episode) => classicApi.createEpisode(podcastKey, episode)

export const updateEpisode = (episode, isAiPodcast) =>
  isAiPodcast ? botApi.updateBotPodcastEpisode(episode) : classicApi.updateEpisode(episode)

export const deleteEpisode = (podcastKey, episodeKey, isAiPodcast) =>
  isAiPodcast
    ? botApi.deleteBotPodcastEpisode(podcastKey, episodeKey)
    : classicApi.deleteEpisode(podcastKey, episodeKey)

export const uploadEpisodeFile = (podcastKey, episodeKey, file, config) =>
  classicApi.uploadEpisodeFile(podcastKey, episodeKey, file, config)

export const getEpisodeUploadingStatus = (taskId) => classicApi.getEpisodeUploadingStatus(taskId)
